<template>
    <router-view/>
</template>

<script>

export default {
  data() {
    return {
      isLogin: false
    }
  },
  mounted() {
    let pageUrl = localStorage.getItem('page-url');
    if (pageUrl && pageUrl == 'home') {
      this.$router.push({name: 'home'})
    } else {
      this.$router.push({name: 'login'})
    }
  }
}
</script>

<style>
body {
  overflow: hidden;
}
/*loading动画暂停，换成自定义图标*/
.el-loading-spinner .circular {
  animation-play-state: paused !important;
}
.el-loading-spinner {
    background-image: url('../src/assets/pika_loading.gif');
    background-repeat: no-repeat;
    background-size: contain ;
    height: 50px;
    width: 50px;
    background-position: center;
  }
</style>